import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const FTLPTLOntimeDelay = ({ delivered_ontime, delivered_delay, intransit_ontime, intransit_delay}) => {
    const [ontime, setOntime] = useState([0, 0]); // Default initialized to avoid undefined issues
    const [delay, setDelay] = useState([0, 0]);  // Default initialized to avoid undefined issues

    useEffect(() => {
        // Ensure values are numbers or default them to 0
        const deliveredOntime = delivered_ontime || 0;
        const deliveredDelay = delivered_delay || 0;
        const intransitOntime = intransit_ontime || 0;
        const intransitDelay = intransit_delay || 0;


        setOntime([deliveredOntime, intransitOntime]); // Delivered data for FTL and PTL
        setDelay([deliveredDelay, intransitDelay]);  // In-Transit data for FTL and PTL
    }, [delivered_ontime, delivered_delay, intransit_ontime, intransit_delay]);
    const dStyles={
        width:'100%',
        height:'100%'
}
// const handleButtonClick = () => {
//     // Call the parent's callback function with the value 'ptl'
//     onChartChange();
// };
    const options = {
        chart: {
            type: 'column',
            // height: 250
        },
        title: {
            text: 'Ontime and Delay Shipments',
            // align: 'left'
        },
        xAxis: {
            categories: ["Delivered", "Undelivered"], // Categories represent FTL and PTL
            crosshair: true
        },
        yAxis: {
            min: 0,
            title: {
                text: "No of Shipments(%)"
            },
            labels: {
                formatter: function () {
                    return this.value;
                }
            },
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.y}%</b>',  // Add % in tooltip
        },
        plotOptions: {
            column: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    style: {
                        color: 'black',
                        textOutline: 'none'
                    },
                    formatter: function () {
                        return this.y + '%';  // Add % next to the value in the data labels
                    },
                    align: 'center',
                    verticalAlign: 'bottom',
                    y: -10,
                    x: 0
                }
            }
        },
        colors: ["#1cc88a","#28bad4"],
        series: [
            {
                name: 'Ontime',  // Legend will show "Delivered"
                data: ontime// FTL and PTL delivered data in one series
            },
            {
                name: 'Delay',  // Legend will show "In-Transit"
                data: delay  // FTL and PTL in-transit data in one series
            }
        ],
        exporting: {
            enabled: false
        },
        credits: {
            enabled: false
        }
    };

    return (
        <div>
            {/* <div className='d-flex justify-content-between'>
                <h1 className='heading3 mt-20p ml-5p' style={{ width: "240px" }}>FTL & PTL Delivery and Intransit Status</h1>
            </div> */}
            {/* Ensure the data is correctly logged before rendering */}
            {/* <button className="btn btn-primary ml-3" onClick={handleButtonClick}>
           {chartType==="FTL" ? "Show PTL" : "Show FTL"}
                </button> */}
            <HighchartsReact highcharts={Highcharts} styles={dStyles} options={options} />
          
        </div>
    );
};

export default FTLPTLOntimeDelay;
